import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';

import {AppComponent} from './app.component';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './views/login/login.component';
import {InterviewLoginComponent} from './views/interviewlogin/interviewlogin.component';
import {PasswordComponent} from './views/password/password.component';
import {AuthGuard} from './_guards/index';
import {routes} from './app.routing';
import {CommonModule} from '@angular/common';
import { DataTablesModule } from 'angular-datatables';


import {AdminComponent} from './containers/admin/admin.component';
import {AuthenticationService, UserService, DashboardService, ApiService, ProjectService,ResponseService, BranchService,ProfileService, PasswordService,SurveyService, IssuecodesService, OrganizationsService, ResourcesService} from './_services/index'; 
import {HttpModule} from '@angular/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
// Import routing module
import {AppRoutingModule} from './app.routing';
import {HttpClientModule} from '@angular/common/http';

// Import 3rd party components
import { BsDropdownModule, TabsModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import {ChartsModule} from 'ng2-charts/ng2-charts';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { NgxCarouselModule } from 'ngx-carousel';
import { DynamicComponentModule } from 'ng-dynamic';
import { LivechatWidgetModule } from '@livechat/angular-widget';


import {ErrorComponent} from './error.component';

// Import containers
import {
    FullLayoutComponent,
    SimpleLayoutComponent,
    FullLayoutPublicComponent,
} from './containers';

const APP_CONTAINERS = [
    FullLayoutComponent,
    SimpleLayoutComponent,
    FullLayoutPublicComponent,
]

// Import components
import {
    AppAsideComponent,
    AppBreadcrumbsComponent,
    AppFooterComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
    APP_SIDEBAR_NAV,
    AppHeaderPublicComponent,
    AppFooterPublicComponent
} from './components';

const APP_COMPONENTS = [
    AppAsideComponent,
    AppBreadcrumbsComponent,
    AppFooterComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
    APP_SIDEBAR_NAV,
    AppHeaderPublicComponent,
    AppFooterPublicComponent
]

// Import directives
import {
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';


const APP_DIRECTIVES = [
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
]




@NgModule({
    imports: [
        BrowserModule, HttpModule,
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        ChartsModule, FormsModule, RouterModule.forRoot(routes),
        ReactiveFormsModule, CommonModule, HttpClientModule,
        FroalaEditorModule.forRoot(), FroalaViewModule.forRoot(),
        DataTablesModule,
        BrowserAnimationsModule,ToastrModule.forRoot(),ModalModule.forRoot(),TooltipModule.forRoot(),
        NgxCarouselModule,
        DynamicComponentModule.forRoot({}),
        LivechatWidgetModule
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        InterviewLoginComponent,
        PasswordComponent,
        AdminComponent,
        ...APP_CONTAINERS,
        ...APP_COMPONENTS,
        ...APP_DIRECTIVES,
         ErrorComponent
    ],
    providers: [AuthenticationService, UserService, DashboardService,ResponseService, ProjectService, ApiService, BranchService,ProfileService,PasswordService,SurveyService,IssuecodesService,OrganizationsService,ResourcesService,{ 
        provide: LocationStrategy,
        useClass: HashLocationStrategy
    }],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/app.module.ts